

export const veoHowto = {
    title: 'How to Create Cinematic Videos with AI Video Generator',
    subtitle:
      'Generate professional videos in three steps. Use keyframe control, multi‑image references, and native audio for cinema‑quality results.',
    steps: [
      { num: '1', title: 'Set Up Your Project with Keyframes or Images', body: 'Enter a detailed prompt or upload images. Use keyframes to control start and end frames or multi‑image references for consistent style.' },
      { num: '2', title: 'Configure Advanced Settings', body: 'Enable keyframes, add references, set aspect ratio, upgrade to 1080P. Native audio provides synchronized sound.' },
      { num: '3', title: 'Generate, Extend, and Download', body: 'Generate with native audio. Use extend to go beyond 8s. Preview and download your preferred quality.' }
    ],
  };
